<template>
  <v-dialog v-model="showModal" width="600" persistent class="z5">
    <v-card>
      <v-card-title class="text-h5 white--text third">
        <span class="d-flex justify-left flex-grow-1">Chevaux en double affectation</span>
        <v-icon size="28" color="white" class="justify-end" @click="closeModal">mdi-close</v-icon>
      </v-card-title>

      <v-card-text class="mt-4 d-flex flex-column">
        <span class="text-subtitle-1 mb-4">
          L'édition de l'horaire crée des chevauches. Voici ce qui va se passer :
        </span>

        <div v-if="sortedConflicts.length" class="conflict-list redScroll">
          <div v-for="(conflict, index) in sortedConflicts" :key="`conflict-${index}`" class="conflict-group mb-4">
            <!-- Stay message (green) -->
            <div class="conflict-item mb-2 pa-3 conflict-stays">
              <div class="d-flex align-center">
                <v-icon small class="mr-2" color="success">mdi-check-circle</v-icon>
                <span class="conflict-text">{{ conflict.stayMessage }}</span>
              </div>
            </div>
            <!-- Remove message (red) -->
            <div class="conflict-item pa-3 conflict-removed">
              <div class="d-flex align-center">
                <v-icon small class="mr-2" color="error">mdi-alert-circle</v-icon>
                <span class="conflict-text">{{ conflict.removeMessage }}</span>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn outlined rounded class="ma-2 third--text" color="white" :disabled="loading" @click="closeModal">
          Non
        </v-btn>
        <v-btn outlined rounded class="ma-2 third--text" color="white" :loading="loading" @click="handleConfirm">
          Oui
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, ref } from '@vue/composition-api';
import { sortArray } from '@/helpers/utils';
import store from '@/store';

export default {
  setup () {
    const loading = ref(false);
    const showModal = computed(() => store.state.horseOverlapModal.show);
    const sortedConflicts = computed(() => ((store.state.horseOverlapModal?.conflicts || []).sort((a, b) => a.projectedSession.start_time - b.projectedSession.start_time)));

    const closeModal = () => {
      store.commit('setHorseOverlapModal', { show: false, conflicts: [], callback: null });
    };

    const handleConfirm = async () => {
      const callback = store.state.horseOverlapModal.callback;
      if (callback) {
        loading.value = true;
        await callback();
        loading.value = false;
      }
      closeModal();
    };

    return {
      showModal,
      sortedConflicts,
      closeModal,
      handleConfirm,
      loading
    };
  }
};
</script>

<style scoped>
.conflict-list {
  max-height: 400px;
  overflow-y: auto;
}

.conflict-item {
  border-radius: 4px;
  border-left: 4px solid;
}

.conflict-stays {
  background-color: rgba(76, 175, 80, 0.1);
  border-left-color: #4caf50;
}

.conflict-removed {
  background-color: rgba(244, 67, 54, 0.1);
  border-left-color: #f44336;
}

.conflict-text {
  font-size: 0.95rem;
  line-height: 1.4;
}
</style>
